import { render, staticRenderFns } from "./policy-invoice.vue?vue&type=template&id=08d6f921&scoped=true&"
import script from "./policy-invoice.vue?vue&type=script&lang=js&"
export * from "./policy-invoice.vue?vue&type=script&lang=js&"
import style0 from "./policy-invoice.vue?vue&type=style&index=0&id=08d6f921&lang=scss&scoped=true&"
import style1 from "./policy-invoice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6f921",
  null
  
)

export default component.exports